import { render } from "./nations.html?vue&type=template&id=b3989df0&external"
import script from "./nations.vue?vue&type=script&lang=js"
export * from "./nations.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__